export default __webpack_public_path__ + "static/media/taskdrag.fd19fda7.mp3";